import * as React from "react"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "src/@/components/ui/select"
import Iconify from "../Iconify"


export default function SelectZui({
    placeholder = "",
    onChange,
    value,
    list,
    itemSelect,
    contentList,
    emptyOption,
    fullWidth,
    clear
}) {
  return (
    <Select
    value={value}
    onValueChange={value => onChange(value)}
    >
             <SelectTrigger className={`w-${fullWidth ? 'full' : '[150px]'} bg-white h-7`}>
         <SelectValue placeholder={placeholder}>
           {value && list?.find(item => item.value === value) ? (
             <div className="flex items-center gap-2">
               {list.find(item => item.value === value).icon && (
                 <Iconify icon={list.find(item => item.value === value).icon} width={16} height={16} className="text-gray-600" />
               )}
               <span>{list.find(item => item.value === value).label || list.find(item => item.value === value).name}</span>
             </div>
           ) : undefined}
         </SelectValue>
       </SelectTrigger>
      <SelectContent className="max-h-[300px] z-[99999999999]">
        {contentList ? (
            contentList
        ) : (
            <SelectGroup>
                {emptyOption && <SelectItem className="font-[10px]" value={emptyOption.value}>{emptyOption.label}</SelectItem>}
                {list?.map((item) => itemSelect(item))}
            </SelectGroup>
        )}
      </SelectContent>
      {value && clear && (
        <button
          type="button"
          onClick={clear}
          className="text-gray-500 hover:text-gray-700 ml-[-4px]"
        >
          <Iconify icon="mdi:close-circle" width={20} height={20} className="text-red-200" />
        </button>
      )}
    </Select>
  )
}
